import React, { useState, useEffect } from 'react';
import { updatePageSEO } from '../utils/seo';

const DreamNumber = () => {
  useEffect(() => {
    // Update SEO for Dream Number page
    updatePageSEO({
      path: '/dream-number',
      title: 'Morning Sunday Teer Dream Number Chart | Dream to Number Guide',
      description: 'Find your Morning Sunday Teer Dream Number using our comprehensive dream to number chart. Interpret dreams for Teer number predictions.',
      robots: 'index, follow'
    });
  }, []);
  
  const dreamChartData = [
    { dream: 'Quarrel b/w husband & wife', direct: '03, 08, 13', house: '0', ending: '3' },
    { dream: 'Erotic dream', direct: '17, 40, 53', house: '4', ending: '7' },
    { dream: 'Bathing in the open', direct: '08, 18, 28', house: '1', ending: '8' },
    { dream: 'Travelling', direct: '06, 14, 18', house: '1', ending: '8' },
    { dream: 'Travelling in an aeroplane', direct: '23, 43, 53', house: '4', ending: '3' },
    { dream: 'Taking a walk', direct: '01, 10, 11', house: '1', ending: '1' },
    { dream: 'Studying', direct: '05, 15, 25', house: '1', ending: '5' },
    { dream: 'Corpse', direct: '09, 19, 99', house: '9', ending: '9' },
    { dream: 'Playing', direct: '00, 27, 40', house: '2', ending: '0' },
    { dream: 'Talking over phone', direct: '94, 96, 98', house: '9', ending: '8' },
    { dream: 'Eating', direct: '01, 02, 05', house: '0', ending: '5' },
    { dream: 'Breast Feeding', direct: '02, 03, 05', house: '0', ending: '2' },
    { dream: 'Male', direct: '06, 16, 26', house: '6', ending: '6' },
    { dream: 'Female', direct: '05, 15, 25', house: '5', ending: '5' },
    { dream: 'Child', direct: '02, 03, 12', house: '2', ending: '3' },
    { dream: 'Police', direct: '07, 08, 87', house: '8', ending: '7' },
    { dream: 'Wild Pig', direct: '04, 06, 46', house: '4', ending: '6' },
    { dream: 'Snake or Ilea fish', direct: '09, 17, 37', house: '3', ending: '7' },
    { dream: 'Cow, goat or buffalo', direct: '12, 18, 19', house: '1', ending: '2' },
    { dream: 'Cow', direct: '04, 14, 24', house: '4', ending: '4' },
    { dream: 'Tiger', direct: '09, 19, 29', house: '9', ending: '9' },
    { dream: 'Dog', direct: '04, 05, 06', house: '4', ending: '5' },
    { dream: 'Horse', direct: '08, 18, 28', house: '8', ending: '8' },
    { dream: 'Bird', direct: '02, 12, 22', house: '2', ending: '2' },
    { dream: 'Elephant', direct: '09, 19, 29', house: '9', ending: '9' },
    { dream: 'Snail', direct: '00, 10, 20', house: '0', ending: '0' },
    { dream: 'Turtle', direct: '09, 19, 29', house: '9', ending: '9' },
    { dream: 'Crab', direct: '02, 06, 62', house: '6', ending: '2' },
    { dream: 'Spider', direct: '06, 12, 62', house: '1', ending: '2' },
    { dream: 'Honey bee', direct: '14, 24, 74', house: '7', ending: '4' },
    { dream: 'Insect', direct: '13, 21, 37', house: '3', ending: '7' },
    { dream: 'Sour fruits', direct: '00, 03, 11', house: '1', ending: '1' },
    { dream: 'Paddy field', direct: '24, 38, 52', house: '3', ending: '4' },
    { dream: 'Pumpkin', direct: '28, 35, 48', house: '3', ending: '8' },
    { dream: 'Bamboo', direct: '00, 01, 10', house: '0', ending: '1' },
    { dream: 'Big Tree', direct: '08, 09, 89', house: '8', ending: '9' },
    { dream: 'Small tree', direct: '02, 03, 08', house: '0', ending: '3' }
  ];

  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="max-w-6xl mx-auto px-4">
        {/* Header */}
        <div className="text-center mb-8">
          <h1 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-2">
            Morning Sunday Dream Chart
          </h1>
        </div>

        {/* Description */}
        <div className="bg-white rounded-lg shadow-md p-6 mb-8">
          <p className="text-gray-700 leading-relaxed">
            Below is the complete <strong>Dream Number chart</strong> based on popular traditional beliefs. 
            Check your dream symbols and match them with the respective numbers.
          </p>
        </div>

        {/* Dream Chart Table */}
        <div className="bg-white rounded-2xl shadow-xl overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full">
              {/* Table Header */}
              <thead>
                <tr className="bg-coral-600 text-white">
                  <th className="py-4 px-4 sm:px-6 text-left font-bold text-base sm:text-lg">
                    Dream
                  </th>
                  <th className="py-4 px-4 sm:px-6 text-center font-bold text-base sm:text-lg">
                    Direct
                  </th>
                  <th className="py-4 px-4 sm:px-6 text-center font-bold text-base sm:text-lg">
                    House
                  </th>
                  <th className="py-4 px-4 sm:px-6 text-center font-bold text-base sm:text-lg">
                    Ending
                  </th>
                </tr>
              </thead>
              {/* Table Body */}
              <tbody>
                {dreamChartData.map((item, index) => (
                  <tr
                    key={index}
                    className={`border-b ${
                      index % 2 === 0 ? 'bg-gray-50' : 'bg-white'
                    } hover:bg-gray-100 transition-colors`}
                  >
                    <td className="py-3 px-4 sm:px-6 text-sm sm:text-base text-gray-900">
                      {item.dream}
                    </td>
                    <td className="py-3 px-4 sm:px-6 text-center text-sm sm:text-base font-semibold text-gray-900">
                      {item.direct}
                    </td>
                    <td className="py-3 px-4 sm:px-6 text-center text-sm sm:text-base font-semibold text-gray-900">
                      {item.house}
                    </td>
                    <td className="py-3 px-4 sm:px-6 text-center text-sm sm:text-base font-semibold text-gray-900">
                      {item.ending}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* Disclaimer */}
        <div className="bg-yellow-50 border-4 border-yellow-400 rounded-2xl p-6 sm:p-8 mt-8">
          <h3 className="text-2xl font-bold text-yellow-800 text-center mb-4">Disclaimer</h3>
          <p className="text-gray-700 text-center leading-relaxed text-base sm:text-lg">
            These dream numbers are based on traditional beliefs and cultural interpretations. 
            There is no scientific guarantee of accuracy. Please use this information responsibly 
            and for entertainment purposes only.
          </p>
        </div>

        {/* Content */}
        <div className="prose prose-lg max-w-none mt-8">
          <h2 className="text-3xl font-bold text-gray-900 mb-4 border-b-2 border-gray-300 pb-2">
            How to Use the Dream Number Chart
          </h2>
          
          <p className="text-gray-700 leading-relaxed mb-6">
            Many followers of Morning Sunday Teer believe that dreams can provide clues about lucky numbers. 
            The Dream Number chart helps you identify potential numbers based on what you dreamed about the night before.
          </p>

          <p className="text-gray-700 leading-relaxed mb-6">
            Simply find the dream symbol or scenario that matches your dream, then check the corresponding 
            <strong> Direct, House, and Ending</strong> numbers. These numbers are derived from traditional 
            interpretations passed down through generations.
          </p>

          <h3 className="text-2xl font-bold text-gray-900 mb-3 mt-8">
            Understanding the Columns
          </h3>
          
          <ul className="list-disc list-inside text-gray-700 space-y-2 mb-6">
            <li><strong>Dream:</strong> The symbol or event you saw in your dream</li>
            <li><strong>Direct:</strong> Direct number predictions (usually 2-3 numbers)</li>
            <li><strong>House:</strong> House number associated with the dream</li>
            <li><strong>Ending:</strong> Ending digit prediction</li>
          </ul>

          <p className="text-gray-700 leading-relaxed mb-6">
            Remember that dream interpretation is subjective and these numbers are meant to guide your 
            analysis rather than guarantee results. Always play responsibly and within your means.
          </p>
        </div>
      </div>
    </div>
  );
};

export default DreamNumber;
